import { Navigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { ROUTES } from '@/utils/constants'
import { LessonsPage } from './LessonsPage'
import { StudentLessonsPage } from './StudentLessonsPage'

/**
 * `/lessons`: единая точка входа.
 * - teacher/admin: интерфейс преподавателя
 * - student: интерфейс ученика
 * - teacher+student: выбор через `?tab=teaching|student` (по умолчанию student), teaching только при роли teacher
 */
export function LessonsIndexPage() {
  const [searchParams] = useSearchParams()
  const roles = useAuthStore((s) => s.user?.roles) ?? []
  const isStudent = roles.some((r) => r.slug === 'student')
  const isTeacher = roles.some((r) => r.slug === 'teacher')
  const isAdmin = roles.some((r) => r.slug === 'admin')
  const tab = searchParams.get('tab')

  if (isStudent && isTeacher) {
    if (tab === 'teaching') {
      return <LessonsPage />
    }
    return <StudentLessonsPage />
  }

  if (isStudent) {
    return <StudentLessonsPage />
  }

  if (isTeacher || isAdmin) {
    return <LessonsPage />
  }

  return <Navigate to={ROUTES.DASHBOARD} replace />
}
